import videojs from 'video.js';
const Component = videojs.getComponent('Component');
const ClickableComponent = videojs.getComponent('ClickableComponent');

class CustomInfoButton extends ClickableComponent {
  constructor(player, options) {
    super(player, options);
    this.controlText(options.buttonTitle);
    this.setListeners();
  }

  setListeners() {
    const { container } = this.options_;
    if (!container) return;
    const activeClassName = 'vjs-custom-info__button_active';
    container.on('AsideContainer/show', () => this.addClass(activeClassName));
    container.on('AsideContainer/hide', () => this.removeClass(activeClassName));
  }

  handleClick() {
    const restrictionModalDialog = this.player().getChild('restrictionModalDialog');
    let { container, isAvailable } = this.options_;
    if (!isAvailable && restrictionModalDialog) {
      restrictionModalDialog.toggleDisplay();
      restrictionModalDialog.onGetAccess(() => {
        this.options_.requestAccess();
      });
      return;
    }
    if (!container) return;
    if (container.isHidden()) {
      container.show();
      this.player().trigger('CustomInfoButton/click');
    } else {
      container.hide();
    }
    restrictionModalDialog.hide();
  }

  createEl() {
    return super.createEl('div', {
      className: `vjs-custom-info__button ${super.buildCSSClass()}`
    });
  }
}

Component.registerComponent('CustomInfoButton', CustomInfoButton);
export default CustomInfoButton;
